import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import domain from '@/config/systemDomain'
import { whatApp, loginStorageDao, getJPushID } from '@/utils'
import { windowInit } from './windowInit'

// ---------------- lib -------------------
import ElementUI from 'element-ui'
Vue.use(ElementUI)
import { Popup, DatetimePicker, NumberKeyboard } from 'vant';
import 'vant/lib/popup/style'
import 'vant/lib/datetime-picker/style'
import 'vant/lib/number-keyboard/style'
import 'vant/lib/toast/style'

// ---------------- define ----------------------
import Api from './api'
Vue.use(Api)
Vue.use(Popup);
Vue.use(DatetimePicker)
Vue.use(NumberKeyboard)

// ---------------- css --------------------
import '@/assets/style/index.scss'

// ---------------- mixins --------------------
import MainMixins from '@/mixins'
Vue.use(MainMixins)

// ---------------- global component --------------------
import base from './components/base'
Vue.use(base)

Vue.config.productionTip = false

windowInit()

let vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


// 微信回调
window.WxLoginCallback = function(code) {
  var source = whatApp()
  // 清除code
  Api.fetch.post({
    url: '/login?method=login_by_phone',
    params: {
      code,
      source: source ? source : undefined
    }
  }).then(res => {
    loginStorageDao.setData({
      hasLogin: true,
      type: 'wechat'
    });
    if (res.phone_bind) {
      getJPushID()
        .then(val => {
          Api.fetch.post({
            url: '/updatedevicealias',
            params: {
              registration_id: val
            }
          }).then(() => {
            window.location.href = domain.center_domain_m + '/#/loading'
          }).catch(() => {
            window.location.href = domain.center_domain_m + '/#/loading'
          })
        })
     
    } else {
      router.push({path: '/mobileRegister'})
    }
  }).catch(() => {
    // 异常回到mobileInit页面
    router.push({path: '/mobileInit'})
  })
}

window.bindWxCallback = function(code) {
  var realname = sessionStorage.getItem('realname')
  var source = whatApp()
  // 清除code
  Api.fetch.post({
    url: '/login?method=bind_wx_by_phone',
    params: {
      code,
      source: source ? source : undefined,
      realname: realname ? realname : undefined
    }
  }).then(res => {
    if (res.phone_bind && res.done) {
      getJPushID()
        .then(val => {
          Api.fetch.post({
            url: '/updatedevicealias',
            params: {
              registration_id: val
            }
          }).then(() => {
            window.location.href = domain.center_domain_m + '/#/loading'
          }).catch(() => {
            window.location.href = domain.center_domain_m + '/#/loading'
          })
        })
    } else {
      router.push({path: '/mobileRegister'})
    }
  }).catch(err => {
    // 异常回到mobileInit页面 清除登陆状态
    Api.fetch.post({
      url: '/login?method=logout'
    }).then( () => {
      router.push({path: '/mobileInit'})
    })
    vue.openMessage(0, err.error_text || '绑定失败')
  })
}

